/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Flex,
  Text,
  Spinner,
  Badge,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
export default ({
  loadingStepUpStatus,
  upgradeStatus,
}: {
  loadingStepUpStatus: (timer: any) => void;
  upgradeStatus: number;
}) => {
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const timeRef = useRef<any>(null);
  useEffect(() => {
    (async function doCall() {
      if (timeRef.current) {
        clearInterval(timeRef.current);
      }

      timeRef.current = setInterval(async () => {
        loadingStepUpStatus(timeRef.current);
        // 在这里执行你的API请求
      }, 10000); // 30秒
      loadingStepUpStatus(timeRef.current);
    })();
  }, [upgradeStatus]);

  useEffect(() => {
    return () => {
      if (timeRef.current) {
        clearInterval(timeRef.current);
      }
    };
  }, []);
  const FlexItem = (props: any) => (
    <Box display="inline" verticalAlign="middle" fontSize="14px" {...props} />
  );
  return (
    <Box p="360px 96px">
      <Flex>
        <FlexItem flex="auto">{}</FlexItem>
        <FlexItem flex="auto" textAlign="center">
          <Badge alignItems="center">
            <Spinner size="xl" />
          </Badge>
          <Text m={20} fontSize={24} lineHeight="32px">
            {t(
              'welcome.enableCloudEmailAndCollaborationProtection.label.provisioning'
            )}
          </Text>
          <Text color={colorStyle.color.secondary}>
            {t(
              'welcome.enableCloudEmailAndCollaborationProtection.label.provisioningDesc'
            )}
          </Text>
        </FlexItem>
        <FlexItem flex="auto">{}</FlexItem>
      </Flex>
    </Box>
  );
};
